import _ from 'lodash'

import {Router} from './router'
import {routerClear, ROUTER_CLEAR} from './router.action'

// tracks whether the requested route has been loaded and then cleared
let ready = true

export const newRouterMiddleware = (loadOnAction) => {
    return (store) => (next) => (action) => {
        let result = next(action)

        switch (action.type) {
            case loadOnAction:
                Router.loadCurrentHash()
                break
            case ROUTER_CLEAR:
                ready = true
                break
            default:
                const route = store.getState().get('route')

                if (ready && !_.isNull(route)) {
                    ready = false
                    Router.load(route)
                    store.dispatch(routerClear())
                }

                break
        }

        return result
    }
}
